import React, { useState } from 'react';
import NavBar from '../_components/navbar';
import { connect, useDispatch } from "react-redux";
import { fazendaAction, tanqueAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonGroup, Container, Row, Col, FormGroup, Label,
    Input, Form, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faCheck } from '@fortawesome/free-solid-svg-icons'
import './styles.css';
import '././styles.css';
import Swal from 'sweetalert2';

const TanqueEdit = (props) => {

    const dispatch = useDispatch();
    const [openTanques, setOpenTanques] = useState(false);

    const [modal, setModal] = useState(false);
    const [, forceUpdate] = React.useState(0);

    const handleChange = prop => event => {
        dispatch(tanqueAction.onChangeProps(prop, event));
    };

    const handleClickOpenTanques = () => {
        setOpenTanques(true)
    };

    const handleCloseTanques = () => {
        setOpenTanques(false)
    };

    const setFile = (event) => {
        props.tanque.arquivo = event.target.files[0];
        forceUpdate();
    }

    const handleImportTanques = () => {

        const { dispatch } = props;

        if (props.tanque.arquivo === null || props.tanque.arquivo === '') {
            alert('Informe um Arquivo válido!');
        } else {

            var formData = new FormData();
            formData.append('periodo', props.tanque.periodo);
            formData.append('file', props.tanque.arquivo);

            //if (params.id) {
            dispatch(tanqueAction.importTanques(formData, true));
            //}
        }
    };

    const handleValidation = () => {

        var valid = true;
        var errors = '';

        if (props.tanque.periodo === null || props.tanque.periodo === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um Período válido!</li><br>';
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });

        }

        return valid;

    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                id_fazenda: props.Tanque.id_fazenda,
                periodo: props.Tanque.periodo,
                volume: props.Tanque.volume,
                vacas_lactacao: props.Tanque.vacas_lactacao,
                media_litros_leite_dia: props.Tanque.media_litros_leite_dia,
                ccs: props.Tanque.ccs,
                ufc: props.Tanque.ufc,
                gordura: props.Tanque.gordura,
                proteina: props.Tanque.proteina,
                nul: props.Tanque.nul,
                preco_litro: props.Tanque.preco_litro,
                faturamento: props.Tanque.faturamento,
                data_cadastro: props.Tanque.data_cadastro,
                usuario_cadastro: props.authentication.user.id
            }

            if (params.id) {
                dispatch(tanqueAction.editTanqueInfo(params.id, payload));
            } else {
                dispatch(tanqueAction.createTanque(payload));
            }

        }

    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/tanques">Lista de Tanques</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Tanque {props.tanque.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="data">Período *</Label>
                                        <Input
                                            id="data"
                                            label="Data *"
                                            className="form-control"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={props.tanque.periodo}
                                            onChange={handleChange('periodo')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <ButtonGroup>
                                        <Button variant="contained" className="mr-1" color="secondary" component='a' href="/tanques">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                        <Button onClick={handleClickOpenTanques} color="primary">Importar Tanques</Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>



            
        </div>
    );

}

const mapStateToProps = (state) => {
    return state;
}

const connectedTanqueEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(TanqueEdit));
export { connectedTanqueEditPage as TanqueEdit };